// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__vWXjI","title":"Header_title__2QFF5","side":"Header_side__Nd-_Q"};